var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqArrowsTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_33651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7433 9.42859C10.4135 9.43126 10.0949 9.30874 9.85192 9.08573L5.99992 5.44116L2.14792 9.08145C1.9056 9.30475 1.58815 9.42871 1.25863 9.42871C0.929119 9.42871 0.611664 9.30475 0.369348 9.08145C0.252819 8.97465 0.159773 8.84479 0.0961193 8.7001C0.0324653 8.55542 -0.000405067 8.39908 -0.000405074 8.24102C-0.000405081 8.08295 0.0324653 7.92661 0.0961193 7.78193C0.159773 7.63725 0.252819 7.50739 0.369348 7.40059L5.11106 2.9203C5.3524 2.69606 5.66963 2.57143 5.99906 2.57143C6.32849 2.57143 6.64573 2.69606 6.88706 2.9203L11.6305 7.40059C11.747 7.50739 11.8401 7.63725 11.9037 7.78193C11.9674 7.92661 12.0002 8.08295 12.0002 8.24102C12.0002 8.39908 11.9674 8.55542 11.9037 8.7001C11.8401 8.84478 11.747 8.97465 11.6305 9.08145C11.3897 9.30574 11.0724 9.42987 10.7433 9.42859",
    fill: "#25313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_33651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrowsTop);
export default __webpack_public_path__ + "static/media/faqArrowsTop.b74caddc45e00997aba9ed8867fdff1b.svg";
export { ForwardRef as ReactComponent };